import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getRoles,
} from '../../axios/rolesRequests';
export interface Role{
  title: string;
  roleId: number;
}
export class RolesStore {
  @observable roleList: any[] = [];

  @observable loading = false;

  @action
  public async getRoles(): Promise<void> {
    try {
      this.loading = true;

      const response = await Connections.wadiDeglaAxios.httpGet(getRoles);
      const roles = response.data;
      roles.forEach((role: Role)=> {if(role.title != 'ADMIN_KENYA') role.title = role.title.toUpperCase() + '_EGYPT'})
      this.roleList = roles;
      
      this.loading = false;
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }
}
